import React, {Component} from 'react';
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
} from 'react-share';
import './megaoverlay.css';

class MegaOverlayMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 'closed',
    }
  }
  toggleMenu() {
    console.log("MERDA")
    this.setState({
      status: this.state.status === 'closed' ? 'opened' : 'closed'
    })
  }
  render() {
    const {status} = this.state;
    return <div className={`megaoverlay ${status}`}>
      <div className="menu" onClick={() => this.toggleMenu()} role="button">
        <div id="nav-toggle"><div className="top"></div><div className="bottom"></div><div className="middle"></div></div>
      </div>
      <div className="contents">
        <h1>elezioni.io</h1>
        <p>Un contenitore di progetti per seguire come i media italiani parlano delle elezioni politiche del 4 Marzo 2018 nelle news.</p>
        <ul className="cards">
          <li className="card">
            <h2><a href="https://2018.elezioni.io/">Politiche 2018</a></h2>
            <p>Scopri le news pi&ugrave; discusse online. Politiche 2018 &egrave; il luogo da cui partire per navigare e cercare gli articoli pi&ugrave; condivisi nei social network.</p>
          </li>
          <li className="card">
            <h2><a href="https://facciafaccia.elezioni.io/">Faccia a faccia con le elezioni</a></h2>
            <p>Le news delle ultime ore visualizzate attraverso la loro popolarit&agrave;, temi e aree politiche.</p>
          </li>
          <li className="card">
            <h2><a href="https://2018.elezioni.io/leggi/chi-siamo#/temi/">Temi</a></h2>
            <p>Quali sono i temi pi&ugrave; discussi nelle news condivise sui social network?</p>
          </li>
          <li className="card">
            <h2><a href="https://2018.elezioni.io/leggi/chi-siamo#/analisi/">Analisi</a></h2>
            <p>Un'analisi <i>Fanta Politica</i> basata sulle news a riguardo delle prossime elezioni.</p>
          </li>
          <li className="card">
            <div className="social">
              <FacebookShareButton
                url="http://facciafaccia.elezioni.io/"
                quote="Faccia a faccia con le elezioni - Scopri come gli italiani condividono le news sulle elezioni del 4 Marzo"
                hashtag="#Elezioni2018"
              className="share-button">
                <FacebookIcon
                  size={32}
                round />
              </FacebookShareButton>
              <TwitterShareButton
                url="http://facciafaccia.elezioni.io/"
                title="Faccia a faccia con le elezioni - Scopri come gli italiani condividono le news sulle elezioni del 4 Marzo"
                hashtags={['Elezioni2018']}
              className="share-button">
                <TwitterIcon
                  size={32}
                round />
              </TwitterShareButton>
            </div>
          </li>
        </ul>
      </div>
    </div>;
  }

}

export default MegaOverlayMenu;



// WEBPACK FOOTER //
// ./src/elezioni/components/Layout/MegaOverlayMenu.js